<template>
  <a-modal
    v-model:visible="visible"
    wrap-class-name="modal-send-to-phone"
    title="固件端预览"
    :width="397"
    :after-close="afterClose"
  >
    <!-- 在这里放置a-modal的内容 -->
    <div class="_sendto leading-tight">
      <p class="font-thin opacity-[0.7]">功能说明：</p>
      <p>
        该功能将当前表盘以手机作为中转，可传送至固件，并在固件端体验表盘效果。
      </p>
      <p class="font-thin opacity-[0.7] mt-4">使用流程：</p>
      <ol class="list-decimal list-outside pl-5">
        <li>请使用数据线将安卓手机与电脑连接；</li>
        <li>点击“传输至手机”；</li>
        <li>打开小米运动健康安卓开发者；</li>
        <li>选择“我的>关于>debug>表盘>输入表盘ID>watchface_default.bin。</li>
      </ol>
      <p>
        <a-button class="mb-2" type="primary" @click="openTutorial">
          教学视频
          <span class="ml-1"
            ><Icon
              icon="play-circle.svg"
              :width="20"
              :height="20"
              fill="transparent"
          /></span>
        </a-button>
      </p>
      <p class="text-[#FF541E] font-bold">注意：</p>
      <p class="text-[#E66138]">
        仅支持小米运动健康安卓开发者版本；<br />
        表盘ID随便输入。
      </p>
    </div>
    <template #footer>
      <a-button
        class=""
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="onOk"
      >
        确定
      </a-button>
      <a-button class="" @click="onCancel">取消</a-button>
    </template>
  </a-modal>

  <modal-watchface-export
    ref="exportModal"
    @valid-fail="() => (visible = false)"
  />
</template>

<script setup lang="ts">
import { PopupType, useEditorPopups } from '@/hooks/use-editor-popups';
import { ElectronApi } from '@/services/electron.api';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { Modal, message } from 'ant-design-vue';
import { ref } from 'vue';

const watchfaceStore = useWatchfaceStore();
const visible = ref(false);
const exportModal = ref();
const loading = ref(false);

defineExpose({
  open: () => {
    visible.value = true;
  }
});

const binFile = ref('');

const pushBinToPhone = async (bin: string) => {
  try {
    loading.value = true;
    const res = await ElectronApi.execAdbFile([
      'push',
      bin,
      'sdcard/watchface_default.bin'
    ]);
    if (res.success) {
      Modal.success({
        title: '推送成功',
        content: '表盘文件已推送到手机根目录下watchface_default.bin',
        okText: '知道了'
      });
    } else {
      throw res;
    }
  } catch (error) {
    console.log(error);
    Modal.warn({
      title: '推送失败',
      content: '请检查电脑是否已连接安卓手机',
      okText: '知道了'
    });
  } finally {
    loading.value = false;
  }
};

// const onExportComplete = async (bin?: string) => {
//   if (!bin) return;
//   // 推送到手机
//   binFile.value = bin;
//   await pushBinToPhone(bin);
// };

const onOk = async () => {
  const bin = binFile.value;

  if (bin) {
    pushBinToPhone(bin);
  } else {
    exportModal.value?.open?.(watchfaceStore.path, async (bin: string) => {
      message.success('表盘导出成功，开始推送到手机');
      binFile.value = bin;
      await pushBinToPhone(bin);
    });
  }
};

const onCancel = () => {
  visible.value = false;
};
const afterClose = () => {
  binFile.value = '';
};

const openTutorial = () =>
  useEditorPopups().togglePopup(PopupType['sendTutorial']);
</script>
<style lang="less">
.modal-send-to-phone {
  .ant-modal-content {
    border-radius: 10px;
    background-color: #000000;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
      background-color: #000000;
      .ant-modal-title {
        font-weight: 400;
      }
    }
    .ant-modal-body {
      border-radius: 0 0 10px 10px;
      overflow: hidden;
    }
    .ant-modal-footer {
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
  }
}
</style>
<style scoped lang="less">
._sendto p {
  margin-bottom: 8px;
}
</style>
